export const DISABLE_TOKEN_INTERCEPTOR = "DISABLE_TOKEN_INTERCEPTOR";
export const DISABLE_COUNTRY_INTERCEPTOR = "DISABLE_COUNTRY_INTERCEPTOR";
